import React from 'react';
import get from 'lodash/get';
import moment from 'moment-timezone';
import { Grid, Typography } from '@mui/material';
import { longDateTimeFormat } from '../../lib/utils';

function CreatedAndUpdatedDisplay({ item, tz }) {
  const closedBy = get(item, 'closedBy');

  return (
    <Grid container>
      <Grid item sm={4}>
        <Typography variant="caption" component="div">
          <strong>Created:</strong>
        </Typography>
        <Typography variant="caption" component="div">
          {moment.tz(get(item, 'createdAt'), tz).format(longDateTimeFormat)}
        </Typography>
        <Typography variant="caption" component="div">
          by
          {' '}
          {get(item, 'createdBy.name', 'Unknown')}
        </Typography>
      </Grid>
      <Grid item sm={4}>
        <Typography variant="caption" component="div">
          <strong>Updated:</strong>
        </Typography>
        <Typography variant="caption" component="div">
          {moment.tz(get(item, 'updatedAt'), tz).format(longDateTimeFormat)}
        </Typography>
        <Typography variant="caption" component="div">
          by
          {' '}
          {get(item, 'updatedBy.name', 'Unknown')}
        </Typography>
      </Grid>
      {item.closedAt
      && (
      <Grid item sm={4}>
        <Typography variant="caption" component="div">
          <strong>Closed:</strong>
        </Typography>
        <Typography variant="caption" component="div">
          {moment.tz(get(item, 'closedAt'), tz).format(longDateTimeFormat)}
        </Typography>
        <Typography variant="caption" component="div">
          by
          {' '}
          {closedBy?.name ? closedBy.name : closedBy || 'Unknown'}
        </Typography>
      </Grid>
      )}
    </Grid>
  );
}

export default CreatedAndUpdatedDisplay;
